import {Component} from '@angular/core';

import {JwtHelperService} from "@auth0/angular-jwt";

import {SERVER_URL} from "../../config";

import {AuthProvider} from "../../providers/auth/auth";

import {HttpClient} from "@angular/common/http";



@Component({

  selector: 'page-home',

  templateUrl: 'home.html'

})

export class HomePage {

  user: string;

  message: string;


  constructor(private readonly authProvider: AuthProvider,

              jwtHelper: JwtHelperService,

              private readonly httpClient: HttpClient) {


    this.authProvider.authUser.subscribe(jwt => {

      if (jwt) {

        const decoded = jwtHelper.decodeToken(jwt);

        this.user = decoded.sub

      }

      else {

        this.user = null;

      }

    });



  }



  ionViewWillEnter() {

    this.httpClient.get(`${SERVER_URL}/users/secret`, {responseType: 'text'}).subscribe(

      text => this.message = text,

      err => console.log(err)

    );

  }



  logout() {

    this.authProvider.logout();

  }



}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts